import "../styles/embeddedImage.scss";
import $ from "jquery";
import { assetDir } from "../../src/scripts/config/paths";

export const tag = `
<div class="wrapper-inmodal">
  <div class="container">
    <div class="content-image"></div>
    <div class="button-element">
      <button class="back"><img src="${assetDir}/images/help/back.png"></img></button>
      <button class="next"><img src="${assetDir}/images/help/next.png"></img></button>
    </div>
  </div>
</div>
`.trim();

export function init(modal, context, helpImages) {
  const wrapperElement = $(".wrapper-inmodal", modal);
  const fileLists = helpImages.files;
  let imageIndex = 0;
  const updateButton = () => {
    if (imageIndex == 0) {
      $(".button-element .back", wrapperElement).hide();
    } else {
      $(".button-element .back", wrapperElement).show();
    }
    if (imageIndex == fileLists.length - 1) {
      $(".button-element .next", wrapperElement).hide();
    } else {
      $(".button-element .next", wrapperElement).show();
    }
  };

  const imgElement = $('<img class="help-image"></img>').appendTo(
    $(".content-image", wrapperElement)
  );
  imgElement.attr("src", helpImages.dir + fileLists[imageIndex]);

  $(".button-element .back", wrapperElement).on("click", function () {
    if (imageIndex - 1 >= 0) {
      imageIndex--;
      imgElement.attr("src", helpImages.dir + fileLists[imageIndex]);
      updateButton();
    }
  });

  $(".button-element .next", wrapperElement).on("click", function () {
    if (imageIndex + 1 < fileLists.length) {
      imageIndex++;
      imgElement.attr("src", helpImages.dir + fileLists[imageIndex]);
      updateButton();
    }
  });

  updateButton();
}
